export default __webpack_public_path__ + "static/Waldo_Waldman_headshot-7d05e20d035165ee3e4c379a18de2225.png";